exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vbF-r-E4avKj8URfLkl17{width:320px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] ._3bOBl9pA9jd1_Zmb4uWNgf.vbF-r-E4avKj8URfLkl17{background:var(--neutralLighter)}@media only screen and (max-width:1400px){._3LSK0fynhhkK7LzEI6gycY.vbF-r-E4avKj8URfLkl17{width:calc(100vw - 1080px);min-width:0}}", ""]);
// Exports
exports.locals = {
	"underlay": "vbF-r-E4avKj8URfLkl17",
	"placeholder": "_3bOBl9pA9jd1_Zmb4uWNgf",
	"shrinkable": "_3LSK0fynhhkK7LzEI6gycY"
};